<template>
  <div>
    <div>商品修改</div>
  </div>
</template>

<script>
export default {
  name: "index"
}
</script>

<style scoped>
.search {
  padding-top: 15px;
  margin: 0px auto;
  margin-bottom: 15px;
  width: 460px;
}
.sreach {
  margin: 5px 0px;
}
</style>
